<template>
  <v-container fluid class="mt-0 pt-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card outlined>
          <v-card-title>
            <h3>
              <v-icon class="mr-3" color="primary">mdi-cog</v-icon>Configurações
            </h3>
          </v-card-title>
          <v-card-text>
            <v-tabs fixed-tabs>
              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
              <!-- 0 - Configuração de Menu-->
              <v-tab-item>
                <Menu></Menu>
              </v-tab-item>
              <!-- 1 - Credenciais de API-->
              <v-tab-item>
                <TokenApiConfiguration></TokenApiConfiguration>
              </v-tab-item>
              <!-- 2 - Configurações Integração -->
<!--              <v-tab-item>-->
<!--                <IntegracaoConfiguration></IntegracaoConfiguration>-->
<!--              </v-tab-item>-->
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Menu from "./menuTab/MenuTabList";
import TokenApiConfiguration from "./tokenApi/TokenApiConfiguration.vue";

export default {
  components: {
    Menu,
    TokenApiConfiguration
  },
  data() {
    return {
      items: [
        "Configuração de Menu",
        "Credenciais de API",
        //  ticket 32074
        // "Integração"
      ]
    };
  },
};
</script>
